const COLORS = {
  ORANGE: '#d87515',
  GREEN: '#008000',
}

export const getColorByGrade = (grade: number) => {
  if (grade < 80) {
    return COLORS.ORANGE
  } else {
    return COLORS.GREEN
  }
}
